












































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarahNew.vue";
import { Tensi, TTV } from "@/types/asesmen";
import { calcBmiNumber, categoryBmiKemenkes } from "@/utils/rumus-kesehatan";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    TekananDarah
  }
})
export default class Antropometri extends Vue {
  @Prop() readonly value;
  @Prop({ default: ["bb", "tb"] })
  fields: [string];

  bb: number = null;
  tb: number = null;
  lla: number = null;
  bbl: number = null;
  lingkarKepala: number = null;

  get imtNumber(): number | null {
    return calcBmiNumber(this.tb, this.bb);
  }

  get imt(): number | null {
    return this.imtNumber === null ? null : Number(this.imtNumber.toFixed(2));
  }

  get isPediatricUnit(): boolean {
    const unitId = userModule.user?.unit_id;
    return unitId === "06" || unitId === "2A";
  }

  get kategoriImt(): string {
    return categoryBmiKemenkes(this.imtNumber, { isPediatric: this.isPediatricUnit });
  }

  get values() {
    return {
      bb: this.bb,
      tb: this.tb,
      imt: this.imt,
      lla: this.lla,
      bbl: this.bbl,
      lingkarKepala: this.lingkarKepala
    };
  }

  changeValue() {
    this.$emit("changeValue", this.values);
  }

  @Watch("value", { deep: true })
  changeVal(val) {
    this.bb = val.bb ?? null;
    this.tb = val.tb ?? null;
    this.lla = val.lla ?? null;
    this.bbl = val.bbl ?? null;
    this.lingkarKepala = val.lingkarKepala ?? null;
  }
}
